import { render, staticRenderFns } from "./WEBSITE.vue?vue&type=template&id=1a99193a&scoped=true&"
import script from "./WEBSITE.vue?vue&type=script&lang=js&"
export * from "./WEBSITE.vue?vue&type=script&lang=js&"
import style0 from "./WEBSITE.vue?vue&type=style&index=0&id=1a99193a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99193a",
  null
  
)

export default component.exports